
import { ssc_2_slidedeck } from './SL49200Sprint02'
import { tUnderConstruction } from './SL00000Sprint00'

import { ssc_1_slidedeckTTR } from './SL49200Sprint01TTR'
import { ssc_2_slidedeckTTR } from './SL49200Sprint02TTR'
import { ssc_3_slidedeckTTR } from './SL49200Sprint03TTR'
import { ssc_4_slidedeckTTR } from './SL49200Sprint04TTR'
import { ssc_5_slidedeckTTR } from './SL49200Sprint05TTR'
import { ssc_6_slidedeckTTR } from './SL49200Sprint06TTR'
import { ssc_7_slidedeckTTR } from './SL49200Sprint07TTR'
import { ssc_8_slidedeckTTR } from './SL49200Sprint08TTR'

const uCSD = [ tUnderConstruction ] // A uCSD is an array of one tUnderConstruction slide.
const uCM = [ uCSD, uCSD ] // A uCM is an array of 2 class sessions each containing a UCSDs.

// The ssc_slidedeck structure is a multiple dimensional array of slidesdecks consisting of 8 modules of 6 classes each. 
// Each slidedeck is an array of 1 to n slides. 
export const ssc_slidedeck = [ uCM, ssc_2_slidedeck, uCM, uCM, uCM, uCM, uCM, uCM ]

export const _CPSC_49200_SLIDEDECK_TTR = [ ssc_1_slidedeckTTR, ssc_2_slidedeckTTR, ssc_3_slidedeckTTR, ssc_4_slidedeckTTR, 
	ssc_5_slidedeckTTR, ssc_6_slidedeckTTR, ssc_7_slidedeckTTR, ssc_8_slidedeckTTR ]